import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface IntellectualPropertyModalPayload {
  data?: null;
  type: ModalType.IntellectualProperty;
  isOpen?: boolean;
}

export const IntellectualPropertyModal = React.forwardRef<
  HTMLElement,
  Pick<IntellectualPropertyModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title="Intellectual Property (IP) Blockchain Co-ownership"
      subtitle="Own a Share of Ideas"
      icon={<Icons.IntellectualPropertyDark />}
      link={{
        title: 'Co-Own CratD2C',
        link: {
          href: ECOSYSTEM_LINKS.intellectualProperty,
          text: ECOSYSTEM_LINKS.intellectualProperty,
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        This part of the ecosystem turns intellectual property (IP) - such as inventions, designs, content, or patents -
        into digital shares on the blockchain.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        Multiple people can co-own and earn from the same IP, with smart contracts automatically splitting royalties.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        It opens the door for investors and creators to share in the value of ideas, transparently and fairly.
      </Typography>
    </ModalSidebar>
  );
});
